// Advanced Filter builder catalogue, backed by GET /api/inpact/fields.
// Backend is the single source of truth for which fields are pickable; the
// frontend no longer hardcodes the list. Refetched on the five-minute snapshot
// cadence and explicitly after a manual refresh request.
import { useQuery } from "@tanstack/react-query";
import { getFields } from "../lib/api";
import type { FieldDef } from "../lib/filterFields";
import type { FieldsResponse } from "../types/inpact";

// Stable identity for the pre-load/error state: `q.data ?? []` would mint a
// NEW array on every render before the fetch resolves, defeating every
// `useMemo(..., [fields])` downstream (AdvancedFilterModal's `fieldByKey`/
// `catalogue`, useCatalogueLabels' label map) for the entire loading window.
const EMPTY_FIELDS: FieldDef[] = [];

export function useFields() {
  const q = useQuery<FieldsResponse>({
    queryKey: ["inpact", "fields"],
    queryFn: getFields,
    staleTime: 5 * 60 * 1000,
  });
  return {
    // Keep unavailable entries: saved filters need their label and the UI's
    // explanation even though the picker must not allow selecting them.
    fields: q.data?.fields ?? EMPTY_FIELDS,
    defaultFilterGroup: q.data?.default_filter_group ?? null,
    isLoading: q.isLoading,
    error: q.error ?? null,
  };
}
